export enum LedColor {
  BACKGROUND = 0x6bc7a6,
  FOREGROUND = 0x006699,
  FOREGROUND_2 = 0x24368f,
  FOREGROUND_3 = 0xb8e0d4,
}

export enum LedCollisionLayer {
  PLATFORMS = 1 << 0,
  PLAYER = 1 << 1,
}
